module.exports = __webpack_public_path__ + "img/montecarlo.63349a8b.svg";